// test1884
(1884 && 0);
